import { useContext, createContext } from 'react'
import { flow, types } from "mobx-state-tree"
import EntityStore from './EntityStore'
import { callApi } from '../utils'
import { values } from 'mobx'
import { first } from 'lodash'
import PlayerEditStore from "./PlayerEditStore";

export const localStoragePlayerService = {
    get: () => localStorage.getItem('liveplayer_player_id'),
    set: (id) => localStorage.setItem('liveplayer_player_id', id),
    has: () => !!localStorage.getItem('liveplayer_player_id'),
    reset: () => localStorage.removeItem('liveplayer_player_id'),
}

export const tokenService = {
    get: () => localStorage.getItem('liveplayer_token'),
    set: (token) => localStorage.setItem('liveplayer_token', token),
    has: () => !!localStorage.getItem('liveplayer_token'),
    reset: () => localStorage.removeItem('liveplayer_token'),
}

const RootStore = types.model('RootStore', {

    entityStore: types.optional(EntityStore, () => EntityStore.create({})),
    playerEditStore: types.optional(PlayerEditStore, () => PlayerEditStore.create()),
    selectedPlayerId: types.maybe(types.integer),
    token: types.maybe(types.maybeNull(types.string)),

}).actions(self => ({

    initialize: flow(function* () {
        if (!self.isAuthenticated) {
            return
        }

        //yield self.loadMe()
        yield self.loadTemplates()
        yield self.loadPlayers()

        self.initSelectedPlayer()
    }),

    initSelectedPlayer() {
        if (!self.entityStore.players.has(localStoragePlayerService.get())) {
            localStoragePlayerService.reset()
            self.setPlayer(first(values(self.entityStore.players))?.id)
        } else {
            self.setPlayer(localStoragePlayerService.get())
        }
    },

    setPlayer(playerId) {
        if (playerId) {
            self.selectedPlayerId = parseInt(playerId)
            localStoragePlayerService.set(playerId)

            self.playerEditStore.edit(self.entityStore.players.get(self.selectedPlayerId))
        }
    },

    loadTemplates: flow(function* () {
        const { data } = yield callApi({ endpoint: '/templates' })

        self.entityStore.add('templates', data, false, 'name')
    }),

    loadPlayers: flow(function* () {
        const { data } = yield callApi({ endpoint: '/players' })

        self.entityStore.add('players', data)
    }),

    loadMe: flow(function* () {
        const { data } = yield callApi({ endpoint: '/me' })

        self.entityStore.set('user', data)
    }),

    authenticate: flow(function* (value) {
        if (value) {
            yield callApi({ endpoint: `/ping`, token: value })

            tokenService.set(value)
            self.token = value
            self.initialize()
        }
    }),

    logout() {
        tokenService.reset()
        self.token = null
    },

})).views(self => ({

    get selectedPlayer() {
        return self.entityStore.players.get(self.selectedPlayerId)
    },

    get isAuthenticated() {
        return !!self.token
    },

})).create({
//    selectedEventId: localStorageEventService.has() ? parseInt(localStorageEventService.get()) : undefined,
    token: tokenService.get(),
})

const RootStoreContext = createContext(null)
export const RootStoreProvider = RootStoreContext.Provider

export function useStore() {
    const store = useContext(RootStoreContext)

    if (store === null) {
        throw new Error('Store cannot be null, please add a context provider')
    }

    return store
}

export default RootStore
